import React, { useState, useRef } from "react"

import { useTranslation } from "react-i18next"

import "../contact-modal/_index.scss"

import ModalRight from "§/src/components/atoms/content/modal-right"
import ContactFormVulnerability from "./contact-form-vulnerability"
import ContactIcon from '§/src/images/svg/contact-us-icon.svg'
import TurnstileWidget from "§/src/components/turnstile-widget"
import { submitGravityForm, SubmitFormError } from "§/src/utils/submit-form"

// Placeholder in attesa del link all'informativa privacy dedicata (ancora in stesura da parte
// del legale Gefran, non pubblicata): non riusare il link privacy standard degli altri form.
const DEFAULT_PRIVACY_POLICY_LINK = "#TODO-privacy-link-in-attesa-legale"

const ContactModalVulnerability = props => {
  const { t } = useTranslation()
  const modalid = 'vulnerabilitydisclosuremodal'

  // formId arriva da prop (11 per la versione EN, un altro id per la futura versione IT)
  const formId = props?.formId
  const dedicatedPrivacyPolicyLink = props?.dedicatedPrivacyPolicyLink || DEFAULT_PRIVACY_POLICY_LINK

  const ctaText = props?.ctaText || t("Segnala una vulnerabilità")
  const modalTitle = props?.modalTitle || t("Segnalazione di vulnerabilità")

  const msgs = {
    fill: props?.msg?.fill || t("Utilizza il form sottostante per segnalare una vulnerabilità di sicurezza relativa ai nostri prodotti o servizi."),
    submit: props?.msg?.submit || t("Grazie per la segnalazione. Il nostro team la valuterà al più presto."),
  }

  const [submitted, setSubmitted] = useState(false)
  const [turnstileToken, setTurnstileToken] = useState(null)
  const [submitError, setSubmitError] = useState(null)
  const turnstileRef = useRef(null)

  const onFormSubmit = async data => {
    if (!turnstileToken) {
      setSubmitError(t("Please complete the anti-bot verification before submitting."))
      return
    }
    setSubmitError(null)

    try {
      const response = await submitGravityForm({
        formId: parseInt(formId, 10),
        formData: data,
        turnstileToken,
      })
      if (response && response.is_valid) {
        setSubmitted(true)
      } else {
        console.error(`Vulnerability form error: ${JSON.stringify(response)}`)
        setSubmitError(t("Submission failed. Please try again."))
        turnstileRef.current?.reset()
        setTurnstileToken(null)
      }
    } catch (e) {
      console.error(`Error submitting form: ${e?.message || JSON.stringify(e)}`)
      let msg = t("Submission failed. Please try again.")
      if (e instanceof SubmitFormError) {
        if (e.code === "turnstile_failed") msg = t("Anti-bot verification failed. Please try again.")
        else if (e.code === "network_error") msg = t("Network error. Please try again.")
      }
      setSubmitError(msg)
      turnstileRef.current?.reset()
      setTurnstileToken(null)
    }
  }

  return (
    <React.Fragment>
      <div className="pt-5"></div>
      <button
        className="cm-floating-cta btn btn-primary rounded-pill"
      >
        <div
          className="btncontainer"
          data-bs-toggle="modal"
          data-bs-target={`#${modalid}`}>
        </div>
        <ContactIcon/>
        <span>{ctaText}</span>
      </button>
      <ModalRight modalid={modalid}>
        <h3 className="contact-modal__title">
          {modalTitle}
        </h3>
        <p className="mb-4">
          { submitted ? msgs.submit : msgs.fill }
        </p>
        <div
          className="d-flex flex-row align-items-center justify-content-end"
          style={{ marginBottom: "3.75rem" }}
        >
          {!submitted && (
            <span className="contact-modal__required-label">
              {t("*campi obbligatori")}
            </span>
          )}
        </div>
        {!submitted && (
          <>
            <ContactFormVulnerability
              onSubmit={onFormSubmit}
              dedicatedPrivacyPolicyLink={dedicatedPrivacyPolicyLink}
              turnstileToken={turnstileToken}
            ></ContactFormVulnerability>
            <div style={{ marginTop: "1rem" }}>
              <TurnstileWidget
                ref={turnstileRef}
                onSuccess={setTurnstileToken}
                onExpired={() => setTurnstileToken(null)}
                onError={() => setTurnstileToken(null)}
              />
            </div>
            {submitError && (
              <div
                role="alert"
                aria-live="polite"
                style={{ color: "#c00", marginTop: "0.75rem" }}
              >
                {submitError}
              </div>
            )}
          </>
        )}
      </ModalRight>
    </React.Fragment>
  )
}

export default ContactModalVulnerability
